import { IsNotEmpty, IsString } from 'class-validator';

export class Bs2BoletoTopicDto {
  @IsString()
  @IsNotEmpty()
  integracaoId: string;
}
